import React from "react";
import {inject, observer} from 'mobx-react';

const PageNotFound = inject("sharedStore","loginStore")(observer((store,val)=>{
    console.log('sharedStore',store,val)
    return (
        <h1> Page Not Found</h1>
    )
})) 
export default PageNotFound;


// WEBPACK FOOTER //
// ./src/components/PageNotFound/PageNotFound.jsx